export function hasGoogleTranslateMarkers(): boolean {
  if (typeof document === "undefined") return false;
  const html = document.documentElement;
  const classNames = html?.className ?? "";
  if (
    classNames.includes("translated-ltr") ||
    classNames.includes("translated-rtl") ||
    html?.getAttribute("translate") === "yes"
  ) {
    return true;
  }
  if (typeof document.querySelector === "function") {
    if (document.querySelector("font[style*='vertical-align']")) return true;
  }
  return false;
}

export function hasDomMutatingExtensionMarkers(): boolean {
  if (typeof document === "undefined") return false;
  if (hasGoogleTranslateMarkers()) return true;
  const html = document.documentElement;
  if (!html) return false;
  const attrs = html.getAttributeNames?.() ?? [];
  for (const name of attrs) {
    if (name.startsWith("data-new-gr-")) return true;
    if (name === "data-gr-ext-installed") return true;
    if (name === "data-gramm" || name === "data-gramm_editor") return true;
  }
  const classNames = html.className ?? "";
  if (
    classNames.includes("reader-mode") ||
    classNames.includes("edge-reading-mode")
  ) {
    return true;
  }
  if (typeof document.querySelector === "function") {
    if (
      document.querySelector(
        "grammarly-extension, grammarly-desktop-integration",
      )
    )
      return true;
  }
  return false;
}

export function isTalismanExtensionNoiseValue(value: string): boolean {
  return value.includes("Talisman extension has not been configured yet");
}
